import { Routes, Route, Navigate } from 'react-router-dom';
import { getUser } from './api.js';
import Login from './pages/Login.jsx';
import Setup from './pages/Setup.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Movimientos from './pages/Movimientos.jsx';
import Productos from './pages/Productos.jsx';
import Reportes from './pages/Reportes.jsx';
import Cierre from './pages/Cierre.jsx';
import AdminUsuarios from './pages/AdminUsuarios.jsx';
import AdminUnidades from './pages/AdminUnidades.jsx';
import Firma from './pages/Firma.jsx';
import Servicios from './pages/Servicios.jsx';
import Cuadre from './pages/Cuadre.jsx';
import Vender from './pages/Vender.jsx';
import Cuenta from './pages/Cuenta.jsx';
import AdminTenants from './pages/AdminTenants.jsx';
import Horario from './pages/Horario.jsx';

function Protected({ children }) {
  return getUser() ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/setup" element={<Setup />} />
      <Route path="/firmar/:id" element={<Firma />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/movimientos" element={<Protected><Movimientos /></Protected>} />
      <Route path="/productos" element={<Protected><Productos /></Protected>} />
      <Route path="/reportes" element={<Protected><Reportes /></Protected>} />
      <Route path="/cierre/:id" element={<Protected><Cierre /></Protected>} />
      <Route path="/admin/usuarios" element={<Protected><AdminUsuarios /></Protected>} />
      <Route path="/admin/unidades" element={<Protected><AdminUnidades /></Protected>} />
      <Route path="/servicios" element={<Protected><Servicios /></Protected>} />
      <Route path="/cuadre" element={<Protected><Cuadre /></Protected>} />
      <Route path="/vender" element={<Protected><Vender /></Protected>} />
      <Route path="/cuenta" element={<Protected><Cuenta /></Protected>} />
      <Route path="/admin/tenants" element={<Protected><AdminTenants /></Protected>} />
      <Route path="/horario" element={<Protected><Horario /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
